"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var TextSmall = _styledComponents["default"].span.withConfig({
  displayName: "TextSmall",
  componentId: "sc-18peg2t-0"
})(["font-size:14px;font-weight:400;line-height:18px;"]);

var _default = TextSmall;
exports["default"] = _default;